module.exports = __webpack_public_path__ + "img/3.4675dbc9.png";